import React from 'react'
import WatchBoxEmptyState from '../../components/dashboard/watch/empty-state'
import useWatch from '../../hooks/useWatch'
import LiveBattleRecord from './live-battle-record'

type Props = {}

const WatchLiveBattles = (props: Props) => {
const {battleList} =useWatch();

  return (
    <div className='d-flex flex-column gap-2 w-100'>
      {battleList.map((battle, index) => {
       return <LiveBattleRecord key={index} match={battle} />
      })}
      {battleList.length === 0 && <WatchBoxEmptyState style={{minHeight:300}} />}
    </div>
  )
}

export default WatchLiveBattles